











































import Vue from 'vue'
import { SpiderRepository } from '@/core/api/spiders'
import SpiderTableFilter from '@/components/spider-table-filter.vue'

export default Vue.extend({
  components: {
    SpiderTableFilter,
  },
  props: {
    initialFilter: {
      type: Object,
      default: null,
    },
  },
  data: () => ({
    loading: false,
    items: [],
    itemsCount: 0,
    page: 1,
    pages: 1,
    filter: {},
    sortColumn: '',
    sortDescending: false,
    headers: [
      {
        text: 'Источник',
        align: 'start',
        value: 'source.name',
      },
      {
        text: 'Статус',
        value: 'status_name',
        width: '120px',
      },
      {
        text: 'Изменение статуса',
        value: 'status_changed',
        width: '120px',
      },
      {
        text: 'Изменение настроек',
        value: 'modified',
        width: '120px',
      },
      {
        text: 'Свежая новость',
        value: 'last_result_publish_date',
        width: '120px',
      },
    ],
  }),
  created() {
    this.filter = { ...this.initialFilter }
    this.fetch()
  },
  methods: {
    async fetch() {
      new SpiderRepository().getPage(this.page, this.filter).then(({ data }) => {
        this.items = data['results']
        this.itemsCount = data['count']
        this.pages = data['pages']
      })
    },
    onItemClick(value) {
      this.$emit('select', value)
    },
    onSortChange() {
      this.fetch()
    },
    onFilterChange(filter: any) {
      this.filter = { ...filter }
      this.fetch()
    },
    onPageChange(page: number) {
      this.page = page
      this.fetch()
    },
  },
})
